import { useState } from "react";
import { Volume2 } from "lucide-react";
import { VOICES, getVoice, setVoice, speak } from "@/lib/api";
import { Nice } from "@/components/Nice";

export const VoicePicker = () => {
  const [voice, setV] = useState(getVoice());
  const pick = (id, label) => {
    setVoice(id); setV(id);
    speak(`Hi! I'm ${label}. Remember the magic word, please!`, id);
  };
  return (
    <section className="pp-card" data-testid="voice-picker">
      <p className="pp-label">Read-aloud voice</p>
      <h2 className="pp-h2">Choose <Nice />'s voice</h2>
      <p className="opacity-75 mt-1">Tap a voice to hear it. This is the default for this device. Each child can have their own voice in the Family area.</p>
      <div className="pp-presets mt-4">
        {VOICES.map(([id, label, desc]) => (
          <button key={id} className={`pp-pill ${voice === id ? "on" : ""}`} onClick={() => pick(id, label)} data-testid={`voice-option-${id}`}>
            <Volume2 className="h-4 w-4 inline mr-1" /> {label} <span className="opacity-70">· {desc}</span>
          </button>
        ))}
      </div>
    </section>
  );
};
